

export enum RepeatStatus {
    All,
    None,
    One
}